const setCircleBlur = ({ commit }, payload) => {
  commit('layer/setCircleBlur', payload, { root: true })
}
const setColorTheme = ({ commit }, payload) => {
  commit('layer/setColorTheme', payload, { root: true })
}
const setFillColor = ({ commit }, payload) => {
  commit('layer/setFillColor', payload, { root: true })
}
const setFillOpacity = ({ commit }, payload) => {
  commit('layer/setFillOpacity', payload, { root: true })
}

export default {
  setCircleBlur,
  setColorTheme,
  setFillColor,
  setFillOpacity
}
